import { createResolutionFromValues } from '../utilities/createResolution';

export type LensSqueezeConfirmationParams = {
  customFramingDecisionWidth: number | null | undefined;
  customFramingDecisionHeight: number | null | undefined;
  lockAspectRatio: boolean;
  currentLensSqueezeValue: number;
  newLensSqueezeValue: number;
};

/**
 * Returns true when changing lens squeeze should show a confirmation that custom framing
 * will be cleared (full custom framing, aspect ratio locked, squeeze value changing)
 */
export function shouldConfirmLensSqueezeChange(
  params: LensSqueezeConfirmationParams
): boolean {
  const {
    customFramingDecisionWidth,
    customFramingDecisionHeight,
    lockAspectRatio,
    currentLensSqueezeValue,
    newLensSqueezeValue,
  } = params;

  const hasFullCustomFraming =
    createResolutionFromValues(
      customFramingDecisionWidth,
      customFramingDecisionHeight
    ) !== null;

  if (!lockAspectRatio || !hasFullCustomFraming) {
    return false;
  }

  return currentLensSqueezeValue !== newLensSqueezeValue;
}
